__turbopack_context__.v({
  "customScrollbar": "Timeline2-module__rYQftq__customScrollbar",
  "modernScrollbar": "Timeline2-module__rYQftq__modernScrollbar",
});
